import { useLingui } from '@lingui/react/macro';
import Modal from 'ud-ui/components/modal';

interface RemoveConfirmModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Подтверждение удаления картинки.
 *
 * Спрашиваем, потому что промахнуться по крестику легко, а вернуть картинку
 * нечем: файл выбирают заново, а сохранённое фото после сохранения формы
 * пропадает с бэкенда.
 */
export function RemoveConfirmModal({ isOpen, onCancel, onConfirm }: RemoveConfirmModalProps) {
  const { t } = useLingui();

  return (
    <Modal.Confirm
      show={isOpen}
      title={t`Удалить изображение?`}
      description={t`После сохранения изображение будет удалено.`}
      confirmText={t`Удалить`}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
